import { DeleteOutlined } from "@ant-design/icons";
import { Popconfirm, Table } from "antd";
import { useParams } from "react-router-dom";
import styled from "styled-components";

const StyledTable = styled(Table)`
  margin-top: 32px;
  margin-bottom: 16px;
`;

function CommercialDebtorTable({ dataSource, handleDelete, isLoading, readOnly = false }) {
  const { debtorId } = useParams();

  const debtorColumns = [
    {
      title: "Company Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => record.name ?? "-",
    },
    {
      title: "EIN",
      dataIndex: "ein",
      key: "ein",
      render: (text) => text || "-",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (text) => text || "-",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => text || "-",
    },
    {
      title: "Fax",
      dataIndex: "fax",
      key: "fax",
      render: (text) => text || "-",
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      hidden: readOnly,
      render: (text, record, index) =>
        // Can't delete primary debtor
        (!debtorId || record?.id?.toString() !== debtorId) && (
          <Popconfirm
            placement="topLeft"
            okText="Yes"
            title="Are you sure you want to delete this debtor?"
            onConfirm={() => handleDelete(record, index)}
          >
            <DeleteOutlined key="delete-debtor" />
          </Popconfirm>
        ),
    },
  ].filter((column) => !column.hidden);

  return (
    <StyledTable
      loading={isLoading}
      dataSource={dataSource}
      // @ts-ignore
      columns={debtorColumns}
      bordered
      scroll={{ x: "max-content" }}
      pagination={false}
    />
  );
}

export default CommercialDebtorTable;
